<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-interactions-contact-reaseons-merge-topics">
    <el-dialog
      v-if="dialogMergeTopicsVisible"
      :visible.sync="dialogMergeTopicsVisible"
      :close-on-click-modal="false"
      :show-close="false"
      ref="mergeTopicsDialog"
      :close-on-press-escape="false"
      append-to-body
      custom-class="mergeTopicsDialog_interactions-dialog"
      :before-close="handleMergeTopicsClose">
      <span slot="title" class="dialog-title">Merge <b>{{this.selectedTopicList.length}} selected</b>  topics into a new topic</span>
      <div v-loading="mergeProcessing">
        <!-- <div class="div-topic-label">Create name for new group</div> -->

        <el-input class="input-holder" ref="topicNameInput" placeholder="Enter group name" maxlength="50" show-word-limit v-model="topicName" autofocus="true" @keypress.enter.native="handleMerge"></el-input>
        <div v-if="isDuplicateName" class="red-warning">
          <span>The AI-Generated topic "{{topicName}}" exists.</span>
        </div>
        <div v-if="isOthers" class="red-warning">
          <span>The AI-Generated topic name can't be Others.</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-cancel" @click="handleMergeTopicsClose">Cancel</el-button>
        <el-button :disabled="isButtonDisabled||isOthers" class="primary-btn btn-confirm" type="primary" @click="handleMerge">Save</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions } from 'vuex';

export default Vue.extend({
  name: 'wy-interactions-contact-reasons-merge-topics',
  props: ['controller'],
  data() {
    return {
      dialogMergeTopicsVisible: false,
      mergeProcessing: false,
      topicName: '',
      selectedTopicList: [],
      isDuplicateName: false,
      preMsgObj: null,
    }
  },
  computed: {
    isButtonDisabled() {
      return (this.preMsgObj!=null) || (this.topicName.trim()=='' || this.mergeProcessing);
    },
    isOthers() {
      return this.topicName.trim().toLowerCase() == 'others';
    }
  },

  methods: {
    ...mapActions(['mergeInteractionContactReasonsTopics', 'fetchProcessList']),

    handleMergeTopicsOpen(selectedList) {
      this.isDuplicateName = false;
      this.selectedTopicList = selectedList;
      this.dialogMergeTopicsVisible = true;
      this.topicName = '';
      setTimeout(()=>{
        this.$refs.topicNameInput.focus();
      }, 100)
    },

    handleMergeTopicsClose() {
      this.dialogMergeTopicsVisible = false;
    },

    handleMerge() {
      let topicDisplayNamesToMerge = this.selectedTopicList.map(el => el.topicDisplayName);

      if(this.topicName && this.topicName != ''){
        if(this.topicName.trim().toLowerCase() !== 'others') {
          let mergeObject = {
            topicDisplayName: this.topicName,
            topicDisplayNamesToMerge: topicDisplayNamesToMerge,
            isMergeToExistingTopic: false
          }
          if(this.controller.taskId) {
            mergeObject.taskId = this.controller.taskId;
          }
          this.mergeTopics(mergeObject);
        }
        else {
          this.isOthers = true;
          if(this.preMsgObj == null){
            this.preMsgObj = this.$message({
              dangerouslyUseHTMLString: false,
              duration: 5000,
              showClose: true,
              customClass: 'merge-warning-msg',
              message: 'The AI-Generated topic name can\'t be "Others".',
              onClose: ()=>{
                this.preMsgObj = null;
              }
            });
          }
        }
      }
      else {
        if(this.preMsgObj == null){
          this.preMsgObj = this.$message({
            dangerouslyUseHTMLString: false,
            duration: 5000,
            showClose: true,
            customClass: 'merge-warning-msg',
            message: 'please give the new topic name.',
            onClose: ()=>{
              this.preMsgObj = null;
            }
          });
        }
      }
    },

    async mergeTopics(mergeObject) {
      this.isDuplicateName = false;
      this.mergeProcessing = true;
      let res = await this.mergeInteractionContactReasonsTopics(mergeObject);
      // let res = {status: 409, data: {errorCode: 4013}}
      //  let res = {status: 200, data: {}}
      this.mergeProcessing = false;

      if(!res) {
        this.$root.showNotificationLocale("error", "error.serverErrorTitle", "error.serverErrorMsg");
      }
      else if(res.status == 200) {
        // this.dialogMergeTopicsVisible = false;
        // this.$root.showProcessWaitDialogue({visible: true, processId: res.data.processId});

        // if(this.controller.$refs.table) this.controller.$refs.table.clearSelection();
        // if(this.controller.$refs.configTopicsTable) this.controller.$refs.configTopicsTable.clearSelection();
        // if(this.controller.controller) this.controller.controller.isModified = true;

        this.dialogMergeTopicsVisible = false;
        this.$message({
          showClose: true,
          message: 'All selected topics have been merged into a new topic called "' + this.topicName + '".',
          customClass: 'interactions-merged-topics-success-message',
          duration: 5000,
          type: 'success',
          iconClass: 'el-icon-circle-check',
          onClose: ()=>{
              this.preMsgObj = null;
            }
        });
        this.fetchProcessList();
        
        if(this.controller.$refs.table) {
          this.controller.$refs.table.clearSelection();
          if(!this.controller.loading) {
            await this.controller.fetchContactReasons({forceRefresh: true});
          }
        }
        else if(this.controller.$refs.configTopicsTable) {
          this.controller.$refs.configTopicsTable.clearSelection();
          await this.controller.loadTopics();
          if(this.controller.controller) this.controller.controller.isModified = true;
        }
      }        
      else if(res.status == 409) {
        if(res.data.errorCode == 4013) {
          this.isDuplicateName = true;
        }
        else {
          // this.$root.showProcessErrorDialogue({controller: this, info: res.data});
          if(this.preMsgObj == null){
            this.$message({
              showClose: true,
              message: 'Merging selected topics are failed',
              customClass: 'interactions-merged-topics-failed-message',
              duration: 5000,
              type: 'error',
              // iconClass: 'el-icon-circle-check',
              onClose: ()=>{
                  this.preMsgObj = null;
                }
            });
          }
        }
      }
    },

    removeTopic(index) {
      if(this.selectedTopicList.length > 2) {
        this.selectedTopicList.splice(index, 1);
      }
      else {
        if(this.preMsgObj == null){
          this.preMsgObj = this.$message({
            dangerouslyUseHTMLString: false,
            duration: 6000,
            showClose: true,
            customClass: 'merge-warning-msg',
            message: 'Must have at least two topics to merge.',
            onClose: ()=>{
              this.preMsgObj = null;
            }
          });
        }
      }
    }
  }
});
</script>

<style lang="scss">
  .wy-interactions-contact-reaseons-merge-topics{
    .el-message--warning {
      background-color: #fdf6ec;
      border-color: #faecd8;
      font-weight: 500;

      .btn-undo {
        border-radius: 5px;
        padding: 5px;
        border: 1px;
        background-color: #E2ECF7;
        font-weight: 600;
        color: #214586;
        color: #005EB8;
      }
      .btn-undo:hover {
        background-color: #E2ECF7;
      }
    }
    .el-message {
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      border-width: 1px;
      border-style: solid;
      border-color: #FFF;
      position: fixed;
      left: 50%;
      top: 90px;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
      background-color:#395167;
      -webkit-transition: opacity .3s,top .4s,-webkit-transform .4s;
      transition: opacity .3s,top .4s,-webkit-transform .4s;
      transition: opacity .3s,transform .4s,top .4s;
      transition: opacity .3s,transform .4s,top .4s,-webkit-transform .4s;
      padding: 15px 15px 15px 20px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      // background: #FCFCFC 0% 0% no-repeat padding-box;
      box-shadow: 0px 3px 6px #00000029;
      border: 1px solid #214586;
      border-radius: 15px;
      width: fit-content !important;
      min-width: unset;
    }
    .el-message .el-icon-warning {
      color: var(--site-font-primary-color) !important;
    }
    .el-message__icon {
        margin-right: 10px;
    }
    .el-icon-warning:before {
        content: "\E7A3";
    }
    .el-message--warning .el-message__content {
      color:#FFF !important;
      padding-right: 30px;
    }  
    .undo-merge-success-message .el-message__content {
      padding-right: 0px;
    }
    .el-message.undo-merge-message p {
      padding-right: 30px !important;
    }
    .el-message p {
      padding-right: 4px !important;
    }
    .el-message__content {
      padding: 0;
      font-size: 14px;
      line-height: 1;
    }
  }
  
  .merge-warning-msg {
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 3px 3px 12px #00000029;
    border: 2px solid #214586;
    border-radius: 10px;
    opacity: 1;
    background-image: url('../../../assets/icons/alert_timed_out.svg');
    background-size: 9%;
    background-position-x: 17px;
    background-position-y: 11px;
    padding: 23px 15px 19px 24px;
    .el-message__icon {
      display: none;
    }
    .el-message__content {
      padding-left: 40px;
      font-size: 15px;
      color: var(--site-font-primary-color)
    }
  }
  .mergeWaitingDialog {
    width: 471px;
    height: 64px;
    display: flex;
    background: #D9EEDF;
    border-radius: 10px;
    margin-left: 88vh !important;
    margin-top: 11vh !important;
    align-items: center;

    .el-dialog__header {
      display:none;
    }
    .el-dialog__body {
      padding: 0px 20px 1px 20px;
      text-align: center;
      height: 63px;
      width: 100%;
      border-radius: 11px;
      border: 1px solid #86D2AE;
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
    .el-dialog__footer {
      padding: 14px 14px;
      display: flex;
      text-align: right;
      box-sizing: border-box;
      align-items: center;
      justify-content: flex-end;
    }
    .waithing-icon {
      background-image: url("../../../assets/icons/icon_calculating_wys.png");
      background-size: 80%;
      background-position-x: 0px;
      background-position-y: -20px;
      background-repeat: no-repeat;
      margin: 0 37%;
      height: 120px;
      width: 135px;
    }
    .new-waithing-icon {
      background-image: url("../../../assets/icons/icon_waiting_wys.svg");
      background-size: 80%;
      background-repeat: no-repeat;
      margin: 0 37%;
      height: 123.35px;
      width: 158px;
      top: 260px;
    }
    .waiting-msg {
      font-size: 16px;
      color: var(--site-font-secondary-color);
      line-height: 23.86px;
      font-weight: 700;
    }
    .waitting-msg-content {
      font-size: 15px;
      padding: 28px;
      word-break: break-word;
      font-weight: 500;
      color: var(--site-font-secondary-color);
      line-height: 22px;
    }
    .waiting-container {
      height: 39px;
      width: 63px;
      left: 443px;
      top: 5px;
      border-radius: 5px;
      padding: 10px, 20px, 10px, 20px;
    }
    .btn-confirm {
      float: right;
      background-color: #0C2837;
      border-radius: 4px;
      height: 35px;
      font-size: 14.22px;
      font-weight: 400;
      padding: 0px 17px;
    }
    .active:hover {
      transform: scale(1.5) perspective(1px);
    }
  }
  .update-failed-msg {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: #FFF;
    position: fixed;
    left: 50%;
    top: 90px;
    color: #FFFFFF !important;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    background-color:#395167;
    // background-color:#000000;
    -webkit-transition: opacity .3s,top .4s,-webkit-transform .4s;
    transition: opacity .3s,top .4s,-webkit-transform .4s;
    transition: opacity .3s,transform .4s,top .4s;
    transition: opacity .3s,transform .4s,top .4s,-webkit-transform .4s;
    padding: 15px 15px 15px 20px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    // background: #FCFCFC 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    // border: 1px solid #214586;
    border: 1px solid #666a6f;
    border-radius: 10px;
    width: fit-content !important;
    min-width: unset;
  }
  .el-message.is-closable.update-failed-msg .el-message__content {
    color: #FFFFFF !important;
    padding-right: 25px;
  }

  .update-success-msg {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: #FFF;
    position: fixed;
    left: 50%;
    top: 90px;
    color: #FFFFFF !important;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    background-color:#395167;
    // background-color:#000000;
    -webkit-transition: opacity .3s,top .4s,-webkit-transform .4s;
    transition: opacity .3s,top .4s,-webkit-transform .4s;
    transition: opacity .3s,transform .4s,top .4s;
    transition: opacity .3s,transform .4s,top .4s,-webkit-transform .4s;
    padding: 15px 15px 15px 20px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    // background: #FCFCFC 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    // border: 1px solid #214586;
    border: 1px solid #666a6f;
    border-radius: 15px;
    width: fit-content !important;
    min-width: unset;
  }
  .update-success-msg .el-message__content {
    color: #FFFFFF !important;
  }
  .input-small-label {
    color: #828E9A;
    font-size: 12px;
    margin-top: 20px;
    height: 14px;
  }
  
  .el-dialog.mergeTopicsDialog_interactions-dialog {
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: var(--site-dialog-primary-shadow);
    border: 1px solid #CAD2DA;
    border-radius: 10px;
    opacity: 1;
    width: 698px !important;
    height: 250px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    .el-dialog__header {
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      height: 66px;
      display: flex;
      border-bottom: 1px dashed #CAD2DA;
      width: 95.7%;
      padding: 0px 0px 0px 30px;
      font-weight: 500;
      align-items: center;
    }
    .el-dialog__body {
      padding: 25px 30px 0px 30px;
      color: var(--site-font-primary-color);
      height: 90px;
      // border-bottom: 1px solid #CAD2DA;
      .div-topic-label,.header-title{
        font-weight: 500;
        font-size: 14.5px;
        margin-bottom: 20px;
        color: var(--site-font-tertiary-color);
      }
    }
    .el-dialog__title {
      line-height: 24px;
      font-size: 18px;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      color: var(--site-font-primary-color);
      margin-left: -10px;
    }

    input.el-input__inner {
      border-width: 1px !important;
      border: 1px solid #CAD2DA;
      // width: 250px;
      height: 38px;
      padding: 0 10px;
      border-radius: 5px;
    }
    .el-input .el-input__count {
      position: relative;
      top: 32px;
      left: 8px;
    }
    .red-warning {
      text-align: left;
      height: 15px;
      // font: italic normal normal 12px/15px Lato;
      font-style: italic;
      font-size: 11px;
      letter-spacing: 0px;
      color: #D54545;
      opacity: 1;
      padding-top: 5px;
    }
    .div-selected-topic-section {
      // padding-top: 15px;
      padding-top: 10px;
      // display: inline-block;
      .div-header {
        height: 20px;

        .header-title{
          margin-top: 2px;
          font-weight: 600;
          font-size: 14px;
          display: inline-block;
        }
        
        .btn-remove-all{
          padding: 4px 7px 5px 7px;
          font-size: 11px;
          height: 22px;
          border-radius: 10px;
          float: right;
        }

      }
      .div-selected-topic-content {
        height: 195px;
        overflow-y: auto;
        overflow-x: hidden;
        background-color: #FFF;
        padding: 7px 0px 7px 0px;
        margin-top: 10px;
        opacity: 1;
        width: 103.8%;
        &::-webkit-scrollbar {
          width: 20px;
          height: 20px;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 150px;
          border: 5px solid transparent;
          border-top: 6px solid transparent;
          background-clip: content-box;
          background-color: #CAD2DA;
        }
        &::-webkit-scrollbar-track {
          background:#FFF;
          border-top: 1px solid #CAD2DA;
        }
        &::-webkit-scrollbar:vertical {
          width: 14px;
        }
        &::-webkit-scrollbar-thumb:vertical {
          border-radius: 160px;
          border: 2px solid transparent;
          border-left: 4px solid transparent;
          background-clip: content-box;
          background-color: #CAD2DA;
        }
        &::-webkit-scrollbar-track:vertical {
          border-top: none !important;
        }

        .div-item {
          color: var(--site-font-primary-color);
          font-weight: normal;
          margin: 0px 0px 10px 0px;
          border-radius: 5px;
          line-height: 19px;
          padding: 8px 0px;
          font-size: 14px;
          font-weight: 500;

          .div-ellipsis-item {
            width: 88%;
            display: inline-block;
            color: var(--site-font-tertiary-color);
            font-size: 14.22px;
            font-weight: 400;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .div-item:hover {
          background: white;
        }

        .el-icon-error{
          float: right;
          // display: none;
          top: 4px;
          left: -10px;
          position: relative;
          color: #606060;
          cursor: pointer;
          font-size: 18px;
        }
        .el-icon-error.is-disabled {
          cursor: not-allowed;
          opacity: 0.5;
        }
        .div-item:hover .el-icon-error {
          display: block; 
        }
      }
    }
    div.dialog-footer {
      justify-content: flex-end;
      display: flex;
      .btn-cancel {
        border: unset;
        color: var(--site-button-cancel-btn-primary-color) !important;
        padding: 7px 30px 7px 30px;
        font-size: 14px;
        height: 36px;
      }
      .btn-cancel:hover {
        background-color: transparent;
      }
      .btn-confirm {
        float: right;
        padding: 8px 16px 8px 16px !important;
        font-size: 15px;
        cursor: pointer;
        font-family: Helvetica Neue, Arial, sans-serif;
        border-radius: 5px;
        margin-right: 19px;
        width: 68px;
      }
    }

    .el-input__inner:focus {
      border-color: #214586;
    }
  }

  .el-message.is-closable.interactions-merged-topics-success-message {
    background-color: #D9EEDF;
    border-color: #86D2AE;
    padding: 10px 10px 10px 10px;
    max-width: 300px;
    .el-icon-circle-check {
      color: #186731;
      margin-right: 10px;
      margin-left: 5px;
    }
     .el-message__content {
      color: var(--site-font-secondary-color);
      padding-right: 30px;
      line-height: 1.2;
      font-size: 14px;
      font-weight: 400;
      padding-right: 25px;
    }
    .el-message__closeBtn.el-icon-close {
      color: #4A4A4F;
      border-left: 1px solid #4A4A4F;
      padding-left: 5px;
    }
  }
</style>